import React from "react";

export default function Loyality() {
  return (
    <div className="flex w-full h-screen justify-center items-center">
      Comming Soon...
    </div>
  );
}
